module.exports = __webpack_public_path__ + "static/img/22.44be7d0c.png";